export default {
  isOpen: false,
  type: 'error',
  message: '',
  callback: {
    fnc: null,
    btnText: null
  }
};
